import React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  contractDelete,
  contractGet,
  contractVerify,
  contractGetbyId,
  revokeContract,
} from "../../actions/proposalAndContract";
import Alert from "../../components/alert/Alert";
import Skeleton from "./../../components/skeleton";
// import "./ContractList.scss";

import Modal from "react-bootstrap/Modal";

const ContractList = ({
  auth,
  proposalAndContract: { ContractsItemData, ContractData },
  contractGet,
  contractVerify,
  contractDelete,
  contractGetbyId,
  revokeContract,
}) => {
  const [paginatedDataItem, setPaginatedDataItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const totalPages = Math.ceil(ContractsItemData?.length / resultsPerPage);

  const handlePageChange = (newPage) => {
    window.scrollTo(0, 0);
    setCurrentPage(newPage);
  };

  const history = useHistory();

  useEffect(() => {
    document.title = "Contract List";
    if (ContractsItemData) {
      setPaginatedDataItem([...ContractsItemData.reverse()]);
    }
  }, [ContractsItemData]);

  useEffect(() => {
    if (!auth.token) {
      history.push("/login");
    }
    contractGet();
  }, []);

  const handleVerify = (id, status) => {
    let data = {
      contract_id: id,
      status: status,
    };
    //debugger;
    contractVerify(data);
    //console.log(ContractsItemData);
  };

  const handleContract = (id) => {
    contractGetbyId(id)
      .then((res) => {
        if (res) {
          if (ContractData) {
            //console.log(ContractData);
            history.push("/contractDetails");
          }
        }
      })
      .catch((err) => {
        console.log(err);
        //yahan error handle karo
      });
  };

  // New state to control the visibility of the MilestoneDetails modal
  const [showMilestoneDetail, setShowMilestoneDetail] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState(null);

  // Handler to open the MilestoneDetails modal
  const handleOpenMilestoneDetail = (milestone) => {
    setSelectedMilestone(milestone);
    setShowMilestoneDetail(true);
  };

  // Handler to close the MilestoneDetails modal
  const handleCloseMilestoneDetail = () => {
    setSelectedMilestone(null);
    setShowMilestoneDetail(false);
  };

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentResults = paginatedDataItem
    ? [...paginatedDataItem].slice(startIndex, endIndex)
    : null;

  return (
    <section className="main-page page-dashboard">
      <div className="container">
        <div className="panel-box">
          <header className="panel-box--header">
            <h1 className="panel-box--title">Contract List</h1>
          </header>
          <main className="panel-box--body">
            <Alert />

            <div className="overflow-scroll">
              {ContractsItemData === null && (
                <table className="table table-layout-fixed table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>
                        <Skeleton width={120} height={25} />
                      </th>
                      <th>
                        <Skeleton width={180} height={25} />
                      </th>
                      <th>
                        <Skeleton width={100} height={25} />
                      </th>
                      <th>
                        <Skeleton width={80} height={25} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
                      <tr key={i}>
                        <td>
                          <Skeleton height={25} />
                        </td>
                        <td>
                          <Skeleton height={25} />
                        </td>
                        <td>
                          <Skeleton height={25} />
                        </td>
                        <td>
                          <Skeleton height={25} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {currentResults && currentResults.length > 0 ? (
                <table className="table table-layout-fixed table-striped">
                  <thead>
                    <tr>
                      {auth.user.type !== "Freelancer" ? (
                        <th>Freelancer</th>
                      ) : (
                        <th>Hire Manager</th>
                      )}

                      <th>Job</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...currentResults].map((contract) => (
                      <tr key={contract._id}>
                        {auth.user.type !== "Freelancer" ? (
                          <td>
                            {contract?.freelancer_id?.user_id?.first_name +
                              " " +
                              contract?.freelancer_id?.user_id?.last_name}
                          </td>
                        ) : (
                          <td>
                            {contract.hire_manager_id.first_name +
                              " " +
                              contract.hire_manager_id.last_name}
                          </td>
                        )}

                        <td>{contract.job_id.headline}</td>
                        <td>{contract.contract_status}</td>
                        <td className="action-data">
                          {auth.user.type === "Freelancer" &&
                            contract.contract_status === "Pending" && (
                              <>
                                <Modal
                                  show={showMilestoneDetail}
                                  onHide={handleCloseMilestoneDetail}
                                  centered
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title>
                                      NDA for Technical Expert at Cyber To
                                      Cyber:
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <ol>
                                      <li>
                                        Cyber To Cyber may conduct appropriate
                                        personnel background checks on Technical
                                        Experts prior to authorizing access to
                                        the platform, data, service, or
                                        infrastructure. The background check may
                                        include criminal and credit record
                                        verification, validation of personal
                                        reference from previous experiences and
                                        or employers, part from academic and
                                        other qualifications.
                                      </li>
                                      <li>
                                        Technical Experts and other individuals
                                        delivering services to Cyber To Cyber
                                        must sign a Non-Disclosure Agreement
                                        (“NDA”).
                                      </li>
                                      <li>
                                        The Technical Experts shall not access
                                        or collect any Personal Data or
                                        sensitive data/ information (financial,
                                        information, account number, financial
                                        statement, etc.) of the customers of the
                                        Cyber To Cyber without the prior written
                                        consent from customer and approval of
                                        the Cyber To Cyber
                                      </li>
                                      <li>
                                        All individuals working at or for Cyber
                                        To Cyber are to comply with Cyber To
                                        Cyber Policies, Procedures and
                                        Standards, as well as the laws and
                                        regulations of the Kingdom of Saudi
                                        Arabia.
                                      </li>
                                      <li>
                                        Confidential Information shall not be
                                        disclosed to any third party without the
                                        express written approval of Cyber To
                                        Cyber, except if such disclosure is
                                        required by law or regulation, in which
                                        case Cyber To Cyber shall promptly be
                                        informed of such disclosure, where this
                                        is legally permissible. The Cyber To
                                        Cyber data shall never be used or shared
                                        for any secondary purpose by the
                                        Technical Experts.{" "}
                                      </li>
                                      <li>
                                        The customer related data shall not be
                                        retained by the Technical Experts longer
                                        than is required for fulfilment of the
                                        service and is to be returned or
                                        destroyed at the completion of the
                                        engagement.{" "}
                                      </li>
                                      <li>
                                        All electronic data shall be permanently
                                        deleted and removed from the Technical
                                        Experts’ electronic system and any
                                        physical copies Data shall be disposed.
                                      </li>
                                      <li>
                                        The Technical Experts shall maintain
                                        compliance with all applicable Kingdom
                                        of Saudi Arabia rules and regulations
                                        for information security and data
                                        protection.
                                      </li>
                                      <li>
                                        The data received by the Technical
                                        Experts through the Cyber To Cyber
                                        platform shall only be used for the
                                        intended purpose and shall never be used
                                        or shared for any secondary purpose,
                                        unless Cyber To Cyber has given written
                                        authority to the Technical Experts.
                                      </li>
                                      <li>
                                        The Technical Experts agrees that the
                                        intellectual property rights of the
                                        Cyber To Cyber including service and the
                                        authorship, systems, ideas, methods of
                                        operation, documentation, are
                                        proprietary intellectual property and
                                        the valuable trade secrets of the Cyber
                                        To Cyber. Any pre-existing proprietary
                                        or Confidential Information of the Cyber
                                        To Cyber used to render the service, or
                                        included into the results or
                                        deliverables of the service provision
                                        including but not limited to software,
                                        appliances, methodologies, code,
                                        templates, tools, policies, records,
                                        working papers, know-how, Data or other
                                        intellectual property, written or
                                        otherwise shall remain exclusive
                                        property of the Cyber To Cyber.
                                      </li>
                                      <li>
                                        The ultimate responsibility of the
                                        client/customer data lies with the
                                        technical expert offering the services,
                                        the experts will be held accountable and
                                        responsible for the protection of the
                                        customer data against leakages,
                                        exposures, and unauthorized disclosures.
                                        Cyber To Cyber cannot be held liable,
                                        accountable, or responsible for any
                                        exposures or infringements.
                                      </li>
                                      <li>
                                        {" "}
                                        The Technical Experts shall be liable
                                        for any breach of obligations listed in
                                        the NDA if the customer related or Cyber
                                        To Cyber trade secrets, financial, or
                                        intellectual properly related
                                        information is disclosed.
                                      </li>
                                      <li>
                                        Upon completion, closure, continuation,
                                        or novation of the project, the data
                                        protection liability of technical
                                        experts shall continue.{" "}
                                      </li>
                                      <li>
                                        The Technical Experts shall not
                                        subcontract the performance of the
                                        services to its 3rd parties without
                                        prior written consent from Cyber To
                                        Cyber. In the event Cyber To Cyber
                                        authorizes the Technical Expertsto
                                        subcontract to a third party the
                                        Technical Expertsshall be held
                                        responsible and accountable for the
                                        activities of the sub-contracting
                                        expert.
                                      </li>
                                    </ol>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <button
                                      onClick={() => {
                                        handleVerify(contract._id, "Accepted");
                                        handleCloseMilestoneDetail();
                                      }}
                                      className="btn btn-primary btn-sn mx-1"
                                    >
                                      Accept
                                    </button>

                                    <button
                                      className="btn btn-secondary"
                                      onClick={handleCloseMilestoneDetail}
                                    >
                                      Close
                                    </button>
                                  </Modal.Footer>
                                </Modal>

                                <button
                                  className="btn btn-primary btn-sn mx-1"
                                  onClick={() =>
                                    handleOpenMilestoneDetail(contract)
                                  }
                                >
                                  Accept
                                </button>

                                <button
                                  onClick={() =>
                                    handleVerify(contract._id, "Rejected")
                                  }
                                  className="btn btn-danger btn-sn mx-1"
                                >
                                  Reject
                                </button>
                              </>
                            )}

                          {auth.user.type === "Client" &&
                            contract.hire_manager_id._id === auth.user._id &&
                            ["Accepted", "Pending"].indexOf(
                              contract.contract_status
                            ) >= 0 && (
                              <button
                                onClick={() => revokeContract(contract._id)}
                                className="btn btn-danger btn-sn mx-1"
                              >
                                Revoke
                              </button>
                            )}

                          <button
                            className="btn btn-primary btn-sn mx-1"
                            onClick={() => handleContract(contract._id)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <>
                  <h4>No Record Found</h4>
                </>
              )}
              {totalPages > 1 && (
                <nav>
                  <ul className="pagination justify-content-center">
                    {[...Array(totalPages)].map((_, index) => {
                      const pageNumber = index + 1;
                      return (
                        <li
                          key={pageNumber}
                          className={`page-item ${
                            pageNumber === currentPage ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </nav>
              )}
            </div>
          </main>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  proposalAndContract: state.proposalAndContract,
});

export default connect(mapStateToProps, {
  contractGet,
  contractVerify,
  contractDelete,
  contractGetbyId,
  revokeContract,
})(ContractList);
